module.exports = __webpack_public_path__ + "static/media/services-submenu-main-product.6aa40088.png";